import { useFeatureGate } from '@statsig/react-bindings';

import { localizationTelehealthClientPromptGate } from '../statsig/gates';
import { BrowserLanguagePrompt } from './BrowserLanguagePrompt';

export function BrowserLanguagePromptWrapper() {
  const { value: isEnabled } = useFeatureGate(localizationTelehealthClientPromptGate);
  if (!isEnabled) return null;
  return <BrowserLanguagePrompt />;
}
